<template>
  <div class="container">
    <el-tabs v-model="activeTab" @tab-click="tabClick" type="card">
      <el-tab-pane label="邮箱" name="accounts">
        <el-container style="height: 80vh; border: 1px solid #eee">
          <el-aside class="mail-menu">
            <el-select v-model="emailAccountsCurrentSelected" placeholder="请选择" class="email-switch" filterable
              @change="setEmailAccounts($event)">
              <el-option v-for="item in emailAccountsOptions" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
            <el-link type="primary" style="margin: 15px 5px;" @click="manageAccounts">账号管理</el-link>
            <i class="el-icon-refresh" style="margin-left: 5px;" @click="refresh" title="刷新"></i>
            <div class="folder-list" v-loading="folder_list_loading" element-loading-text="正在获取文件夹">
              <el-menu :default-active="folderDefaultActive">
                <el-menu-item @click="queryFolderEmails(item); setFolderIndex(index)" :index="`1-${index + 1}`"
                  :key="index" v-for="(item, index) in folderList">{{ item.folder }} ({{ item.total }})</el-menu-item>
              </el-menu>
            </div>
          </el-aside>
          <el-aside class="mail-list" v-loading="mail_list_loading" element-loading-text="正在获取邮件列表">
            <el-menu :default-active="mailDefaultActive">
              <el-menu-item :index="`2-${index + 1}`" @click="queryEmailDetail(item); setMailListIndex(index)"
                :key="index" v-for="(item, index) in mailsList" :style="item.is_seen == 0 ? 'font-weight: bold;' : ''">
                <div v-if="item.subject == null">无主题</div>
                <div v-if="item.subject != null && item.subject.length < 24">{{ item.subject }}</div>
                <div v-if="item.subject != null && item.subject.length >= 24">{{ item.subject.substring(0, 24) + '...'
                }}</div>
                <div class="email-date">{{ item.date }}</div>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-container v-loading="email_main_content_loading" element-loading-text="正在获取邮件内容, 消耗时长受邮件正文和附件大小影响, 请稍候">
            <el-header height="auto">
              <el-main v-if="JSON.stringify(this.email) !== '{}'">
                <div class="mail-main-info">
                  <span>
                    <b>{{ email.subject }}</b>
                  </span>
                  <span style="display: block;">
                    <el-link icon="el-icon-top-left" :underline="false" title="回复" @click="reply"> 回复</el-link>
                    &nbsp;
                    <el-link icon="el-icon-right" :underline="false" title="转发"
                      @click="forward">转发</el-link>&nbsp;&nbsp;
                    <span style="float: right;color: #777;">发送者IP:{{ email.sender_ip ? '[' + email.sender_ip + ']' :
                      'unknown' }} 参考地区: {{ email.place }}</span>
                  </span>
                  <span>
                    <span class="label">发件人</span>
                    <span class="value">
                      <el-link :underline="false" @click="composeTo(email.from_address)">{{ (email.from_name ?
                        email.from_name : '') + '&lt;' + email.from_address + '&gt;' }}</el-link>
                    </span>
                  </span>
                  <span>
                    <span class="label">收件人</span>
                    <span class="value">
                      <el-link :underline="false" v-for="(item, index) in email.to" :key="item.value"
                        :label="item.label" :value="item.value" @click="composeTo(item.email)">
                        {{ (item.name ? item.name : '') + '&lt;' + item.email + '&gt;' }} <span
                          v-if="index < email.to.length - 1">,</span>
                      </el-link>
                    </span>
                  </span>
                  <span v-if="email.cc && email.cc.length > 0">
                    <span class="label">抄送</span>
                    <span class="value">
                      <el-link :underline="false" v-for="(item, index) in email.cc" :key="item.value"
                        :label="item.label" :value="item.value" @click="composeTo(item.email)">
                        {{ (item.name ? item.name : '') + '&lt;' + item.email + '&gt;' }}
                        <span v-if="index < email.cc.length - 1">,</span>
                      </el-link>
                    </span>
                  </span>
                  <span>
                    <span class="label">时间</span>
                    <span class="value">{{ email.date }}</span>
                  </span>
                  <span v-if="email.attachments && email.attachments.length > 0">
                    <span class="label">附件</span>
                    <span class="value compose-attachments">
                      <el-link :underline="false" v-for="item in email.attachments" :key="item.value"
                        :label="item.label" :value="item.value" @click="downloadAttachment(item)">
                        {{ item.name + ' (' + item.size + ')' }}
                      </el-link>
                    </span>
                  </span>
                </div>
              </el-main>
            </el-header>
            <el-main class="email_main_content">
              <template v-if="email.text_html != '' && email.text_html != null">
                <iframe :srcdoc="email.text_html"></iframe>
              </template>
              <template v-if="email.text_html == '' || email.text_html == null">
                <div v-html="email.text_html"></div>
              </template>
            </el-main>
          </el-container>
        </el-container>
        <el-dialog title="邮箱账号管理" :visible.sync="emailAccountsVisible">
          <el-row>
            <el-button type="primary" plain icon="el-icon-plus" @click="addEmailAccount">添加账号</el-button>
          </el-row>
          <br>
          <template>
            <el-table :data="emailAccountsData">
              <el-table-column property="username" label="账号" width="300"></el-table-column>
              <el-table-column prop="status" label="启用">
                <template v-slot="scope">
                  <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dedede"
                    @change="emailAccountsToggleStatus(scope.row)">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column property="created_at" label="创建时间" width="200"></el-table-column>
              <el-table-column property="creator" label="创建人" width="120"></el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <el-button icon="el-icon-edit" @click="emailAccountsEdit(scope.row)" title="编辑" circle></el-button>
                  <!--<el-button type="danger" icon="el-icon-delete" @click="emailAccountsDel(scope.row)"
                    title="删除" circle></el-button>-->
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div class="pagenation">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="emailAccountsTotal"
              @size-change="changeEmailAccountsSize" @current-change="CurrentEmailAccountsChange"
              :page-sizes="[10, 20, 50, 100]" :page-size="emailAccountsSize">
            </el-pagination>
          </div>
        </el-dialog>
        <el-dialog title="添加账号" :visible.sync="addEmailAccountVisible">
          <el-form :model="addEmailAccountForm" label-width="100px" :rules="addEmailAccountRules"
            ref="addEmailAccountForm" v-loading="addEmailAccountLoading" element-loading-text="验证中">
            <el-row>
              <el-col :span="20">
                <el-form-item label="用户名" prop="username">
                  <el-input v-model="addEmailAccountForm.username" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="密码" prop="password">
                  <el-input type="password" v-model="addEmailAccountForm.password"
                    autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="">
                  <!-- <el-switch v-model="addEmailAccountForm.sync" active-color="#13ce66" inactive-color="#dedede">
                  </el-switch> -->
                  <i class="el-icon-warning-outline"></i>
                  <i>首次添加账号时, 若存在较多历史邮件, 将需要较多时间初始化.</i>
                </el-form-item>
                <el-form-item label="">
                  <!-- <el-switch v-model="addEmailAccountForm.sync" active-color="#13ce66" inactive-color="#dedede">
                  </el-switch> -->
                  <i class="el-icon-warning-outline"></i>
                  <i>由于会根据邮件写入客户表 建议不要绑定非业务邮箱</i>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddEmailAccount">取 消</el-button>
            <el-button type="primary" @click="confirmAddEmailAccount">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="编辑账号" :visible.sync="editEmailAccountVisible">
          <el-form :model="editEmailAccountForm" label-width="100px" :rules="editEmailAccountRules"
            ref="editEmailAccountForm" v-loading="editEmailAccountLoading" element-loading-text="验证中">
            <el-row>
              <el-col :span="20">
                <el-form-item label="用户名" prop="username">
                  <el-input v-model="editEmailAccountForm.username" autocomplete="new-password" readonly
                    disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="密码" prop="password">
                  <el-input type="password" v-model="editEmailAccountForm.password"
                    autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="">
                  <i class="el-icon-warning-outline"></i>
                  <i>若密码为空, 则不作修改.</i>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelEditEmailAccount">取 消</el-button>
            <el-button type="primary" @click="confirmEditEmailAccount">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane :label="composeTitle" name="compose" v-loading="composeLoading"
        element-loading-text="Email is being sent, please wait">
        <el-row>
          <el-button icon="el-icon-position" @click="composeSend">发送</el-button>
          <el-button icon="el-icon-download" @click="composeDraft">保存草稿</el-button>
          <el-button icon="el-icon-paperclip" @click="composeAttachments = true">附件</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="composeGiveup">重置</el-button>
          <!-- <el-button type="success" icon="el-icon-notebook-2" @click="showTemplates">模板</el-button> -->
          <el-select v-model="composeForm.composeEmailAccount" placeholder="请选择" class="email-switch" filterable
            style="width: 300px; float: right;">
            <el-option v-for="item in emailAccountsOptions" :key="item.value" :label="item.label" :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-row>
        <br>
        <el-row>
          <el-form ref="form" :model="composeForm" label-width="80px" class="composeForm">
            <el-form-item label="收件人">
              <el-input v-model="composeForm.receiver"></el-input>
            </el-form-item>
            <el-form-item label="抄送">
              <el-input v-model="composeForm.cc"></el-input>
            </el-form-item>
            <el-form-item label="主题">
              <el-input v-model="composeForm.subject"></el-input>
            </el-form-item>
            <el-form-item label="附件" v-if="composeForm.attachmentsList.length > 0">
              <el-link :underline="false" v-for="item in composeForm.attachmentsList" :key="item.value"
                :label="item.label" :value="item.value" class="attachments">
                {{ item.name }}
              </el-link>
            </el-form-item>
          </el-form>
        </el-row>
        <quill-editor v-model="composeForm.content" ref="myQuillEditor" :optinotallow="editorOption"
          style="min-height: 50vh !important;">
        </quill-editor>
        <el-dialog title="选择附件" :visible.sync="composeAttachments">
          <el-form label-width="120px">
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag multiple :action="uploadApi" :headers="headersObj"
                  :on-success="composeAttachmentsSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="composeAttachments = false, attachmentsList = []">取 消</el-button>
            <el-button type="primary" @click="composeAttachments = false">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="模板管理" :visible.sync="composeTemplates">
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="composeTemplates = false">关 闭</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

var _EditorOption_ = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'], // 加粗 斜体 下划线 删除线
      [{ size: [12, 14, 16] }], // 字体大小
      [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
      [{ align: [] }], // 对齐方式
      ['clean'], // 清除文本格式
      ['link', 'image', 'video'] // 链接、图片、视频
      // ['link'] // 链接、图片、视频
    ]
  },
  placeholder: '请输入正文'
};
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
];

export default {
  name: 'ALCMailer',
  components: {
    Nav,
    quillEditor
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'files/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      activeTab: 'accounts',
      composeTitle: '写邮件',
      emailAccountsOptions: [],
      emailAccountsCurrentSelected: '',
      emailAccountsVisible: false,
      emailAccountsData: [],
      emailAccountsTotal: 0,
      emailAccountsSize: 10,
      emailAccountsCurrentPage: 1,
      addEmailAccountVisible: false,
      addEmailAccountLoading: false,
      addEmailAccountForm: {
        username: '',
        password: '',
        sync: false
      },
      addEmailAccountRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' }
        ]
      },
      accountId: 0,
      folderList: [],
      folderDefaultActive: '1-1',
      mailDefaultActive: '2-1',
      mailsList: [],
      email: {},
      editorOption: _EditorOption_,
      composeForm: {
        message_id: '',
        composeEmailAccount: '',
        receiver: '',
        cc: '',
        subject: '',
        attachmentsList: [],
        content: ''
      },
      composeAttachments: false,
      composeLoading: false,
      composeTemplates: false,
      folder_list_loading: false,
      mail_list_loading: false,
      email_main_content_loading: false,
      folder_index: 0,
      mail_list_index: 0,
      editEmailAccountVisible: false,
      editEmailAccountLoading: false,
      editEmailAccountForm: {
        id: null,
        username: null,
        password: null,
        sync: false
      },
      editEmailAccountRules: {
      }
    }
  },
  mounted() {
    this.getEmailAccountsOptions();
    // this.intervals = setInterval(() => {
    //   if (this.activeTab === 'accounts') {
    //     this.getEmailAccountsFolderInfo(this.emailAccountsCurrentSelected, true);
    //   }
    // }, 60000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'emailList':
          this.getEmailAccountsOptions();
          break;
      }
    },
    refresh() {
      this.getEmailAccountsFolderInfo(this.emailAccountsCurrentSelected);
    },
    setFolderIndex(index) {
      this.folder_index = index;
    },
    setMailListIndex(index) {
      this.mail_list_index = index;
    },
    setEmailAccounts(event) {
      this.folder_index = 0;
      this.mail_list_index = 0;
      this.getEmailAccountsFolderInfo(event);
    },
    async getEmailAccountsOptions(emailAccountsCurrentSelected = 0) {
      await this.$axios.get(`mailer/accounts/options`).then((response) => {
        if (response.data.code === 200 && response.data.data.length > 0) {
          let data = response.data.data;
          let emailAccountsCurrentSelected = data[0].value;
          this.emailAccountsOptions = data
          this.emailAccountsCurrentSelected = emailAccountsCurrentSelected;
          this.getEmailAccountsFolderInfo(emailAccountsCurrentSelected);
        }
      });
    },
    async getEmailAccountsFolderInfo(id, sync = false) {
      this.folder_list_loading = true
      if (id && id !== '') {
        this.accountId = id
        this.composeForm.composeEmailAccount = id
        await this.$axios.get(`mailer/folders?id=` + id).then((response) => {
          this.folderList = response.data.data
          this.folder_list_loading = false
          setTimeout(() => {
            if (this.folderList.length > 0) {
              this.queryFolderEmails(this.folderList[this.folder_index], sync)
            } else {
              this.mailsList = [];
              this.email = {};
            }
          })
        })
      }
    },
    getAccountsList() {
      this.$axios.get(`mailer/accounts/list`, {
        params: {
          size: this.emailAccountsSize,
          page: this.emailAccountsCurrentPage
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.emailAccountsData = response.data.data.data
          this.emailAccountsTotal = response.data.data.total
        }
      });
    },
    changeEmailAccountsSize(val) {
      this.emailAccountsSize = val;
      this.getAccountsList();
    },
    CurrentEmailAccountsChange(val) {
      this.emailAccountsCurrentPage = val;
      this.getAccountsList();
    },
    emailAccountsToggleStatus(row) {
      this.$axios.post('mailer/accounts/toggle_status', {
        id: row.id,
        status: row.status
      }).then((response) => {
        if (response.data.code === 200) {
          this.getEmailAccountsOptions();
        } else {
          row.status = !row.status
          this.$notify({
            title: 'failed',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    emailAccountsDel(row) {
      this.$confirm('此操作将永久删除该邮箱, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('mailer/accounts/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getAccountsList();
            setTimeout(() => {
              this.getEmailAccountsOptions();
            })
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    emailAccountsEdit(row) {
      this.editEmailAccountVisible = true;
      this.editEmailAccountForm.id = row.id;
      this.editEmailAccountForm.username = row.username;
    },
    manageAccounts() {
      this.emailAccountsVisible = true;
      this.getAccountsList()
    },
    addEmailAccount() {
      this.addEmailAccountVisible = true;
    },
    cancelAddEmailAccount() {
      this.addEmailAccountVisible = false;
      this.addEmailAccountForm = {}
    },
    confirmAddEmailAccount() {
      this.$refs.addEmailAccountForm.validate(valid => {
        if (valid) {
          this.addEmailAccountLoading = true
          this.$axios.post(`/mailer/accounts/add`,
            this.addEmailAccountForm
          ).then((response) => {
            this.addEmailAccountLoading = false
            if (response.data.code === 200) {
              this.$notify({
                title: 'success',
                message: '保存成功',
                type: 'success'
              })
              this.addEmailAccountVisible = false;
              this.addEmailAccountForm = {
                username: '',
                password: ''
              }
              this.getAccountsList();
              setTimeout(() => {
                this.getEmailAccountsOptions();
              })
            } else {
              this.$notify({
                title: 'error',
                message: response.data.data,
                type: 'error'
              })
            }
          })
        }
      })
    },
    cancelEditEmailAccount() {
      this.editEmailAccountVisible = false;
      this.editEmailAccountForm = {
        id: null,
        username: null,
        password: null,
        sync: false
      }
    },
    confirmEditEmailAccount() {
      this.$refs.editEmailAccountForm.validate(valid => {
        if (valid) {
          this.editEmailAccountLoading = true
          this.$axios.post(`/mailer/accounts/save`,
            this.editEmailAccountForm
          ).then((response) => {
            this.editEmailAccountLoading = false
            if (response.data.code === 200) {
              this.$notify({
                title: 'success',
                message: '保存成功',
                type: 'success'
              })
              this.editEmailAccountVisible = false;
              this.editEmailAccountForm = {
                id: null,
                username: null,
                password: null,
                sync: false
              }
              this.getAccountsList();
              setTimeout(() => {
                this.getEmailAccountsOptions();
              })
            } else {
              this.$notify({
                title: 'error',
                message: response.data.data,
                type: 'error'
              })
            }
          })
        }
      })
    },
    async queryFolderEmails(ev, sync = false) {
      this.mail_list_loading = true;
      let accountId = this.accountId;
      let folder = ev.folder;
      this.$axios.get(`mailer/folders/detail?id=` + accountId + `&folder=` + folder).then((response) => {
        if (response.data.code === 200) {
          this.mailsList = response.data.data
          this.mail_list_loading = false;
          setTimeout(() => {
            if (this.mailsList.length > 0) {
              if (sync === false) {
                this.queryEmailDetail(this.mailsList[this.mail_list_index])
              }
            }
          })
        }
      });
    },
    queryEmailDetail(ev) {
      this.email_main_content_loading = true;
      let message_id = encodeURIComponent(ev.message_id)
      let mail_id = ev.id;
      this.$axios.get(`mailer/email/detail?id=` + mail_id + `&seen=1`).then((response) => {
        if (response.data.code === 200) {
          this.email_main_content_loading = false;
          this.email = response.data.data
        }
      });
    },
    downloadAttachment(ev) {
      window.location.href = this.$axios.defaults.baseURL + 'mailer/email/attachment_download?id=' + ev.id;
    },
    composeAttachmentsSuccess(response) {
      if (response.code === 200) {
        this.composeForm.attachmentsList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    composeSend() {
      if (this.composeForm.receiver === '' || this.composeForm.subject === '') {
        this.$notify({
          title: 'Error',
          message: '收件人和主题不能为空',
          type: 'error'
        })
      }
      this.composeLoading = true
      this.$axios.post(`mailer/email/send`, this.composeForm).then((response) => {
        this.composeLoading = false
        if (response.data.code === 200) {
          this.$notify({
            title: 'Success',
            message: 'Email sent success',
            type: 'success'
          })
          let composeEmailAccount = this.composeForm.composeEmailAccount
          setTimeout(() => {
            this.composeForm = {
              composeEmailAccount: composeEmailAccount,
              receiver: '',
              cc: '',
              subject: '',
              attachmentsList: [],
              content: ''
            }
            this.composeTitle = '写邮件'
          })
        } else {
          this.$notify({
            title: 'Error',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    composeDraft() {
      this.$axios.post(`mailer/email/draft`, this.composeForm).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: 'Success',
            message: 'Draft saved success',
            type: 'success'
          })
        } else {
          this.$notify({
            title: 'Error',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    composeTo(to) {
      this.activeTab = 'compose';
      this.composeForm.receiver = to;
    },
    forward() {
      this.activeTab = 'compose';
      this.composeTitle = 'Fw';
      this.composeForm.subject = 'Fw: ' + this.email.subject
      this.composeForm.message_id = this.email.message_id
      this.composeForm.attachmentsList = []
      let html = `  
      <br><br>------------------------------------------------------------------<br>  
        <div>  
          <p><b>发件人:</b> ${this.email.from_name ? this.email.from_name : ''}</p>  
          <p><b>发送时间:</b> ${this.email.date}</p>  
          <p><b>收件人:</b> ${this.email.to_string}</p>  
          ${this.email.cc_string ? `<p><b>抄送:</b> ${this.email.cc_string}</p>` : ''}  
          <p><b>主题:</b> ${this.email.subject}</p>  
        </div>  
        <br><br>  
      `;
      this.composeForm.content = html + (this.email.text_html !== '' ? this.email.text_html : this.email.text_plain)
    },
    reply() {
      this.activeTab = 'compose';
      this.composeTitle = 'Re';
      this.composeForm.receiver = this.email.from_address
      this.composeForm.subject = 'Re: ' + this.email.subject
      this.composeForm.message_id = this.email.message_id
      this.composeForm.attachmentsList = []
      let html = `  
      <br><br>------------------------------------------------------------------<br>  
        <div>
          <p><b>发件人:</b> ${this.email.from_name ? this.email.from_name : ''}</p>  
          <p><b>发送时间:</b> ${this.email.date}</p>  
          <p><b>收件人:</b> ${this.email.to_string}</p>  
          ${this.email.cc_string ? `<p><b>抄送:</b> ${this.email.cc_string}</p>` : ''}  
          <p><b>主题:</b> ${this.email.subject}</p>  
        </div>  
        <br><br>  
      `;
      // if(this.email.text_html != ''){
      //   this.composeForm.content = this.email.text_html.replace('<body>', `<body>${html}`);
      // }else{
      //   this.composeForm.content = html + this.email.text_plain
      // }
      // let modifiedHtml = existingHtml.replace('<body>', `<body>${html}`);
      this.composeForm.content = html + (this.email.text_html !== '' ? this.email.text_html : this.email.text_plain)
    },
    composeGiveup() {
      this.$confirm('此操作不可恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.activeTab = 'compose';
        this.composeTitle = '写邮件';
        this.composeForm = {
          message_id: '',
          composeEmailAccount: '',
          receiver: '',
          cc: '',
          subject: '',
          attachmentsList: [],
          content: ''
        }
      })
    },
    showTemplates() {
      this.composeTemplates = true
    },
    beforeDestroy() {
      clearInterval(this.intervals);
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 99%;
  overflow: auto;
  border: none;
}

.el-aside {
  overflow-x: hidden;
}

.selected {
  background: #F1F1F1;
}

.email-switch {
  width: 100%;
}

.folder-list ul li {
  border-bottom: 1px solid #ebebeb;
}

.mail-menu {
  width: 200px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.mail-list {
  width: 300px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.mail-list ul li {
  padding-top: 4px;
  line-height: 24px !important;
  border-bottom: 1px solid #ebebeb;
}

.email-date {
  font-size: 12px !important;
  color: #303133 !important;
}

.mail-main-info {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  word-wrap: break-word;
  word-break: break-all;

  b {
    font-size: 16px;
    color: #000 !important;
  }

  span {
    margin: 3px 0;
    display: flex;
    align-items: center;
  }

  .label {
    width: 50px;
    color: #000;
    align-items: ss;
  }

  .value {
    color: #666;
    width: 100%;
    display: block;
    word-wrap: break-word;
    word-break: break-all;
  }
}

.email_main_content {
  word-break: break-all !important;
  padding: 0 !important;
}

.attachments {
  padding: 0px 4px;
  margin: 2px 4px 2px 0px;
  border: solid 1px #CBCBCB;
  border-radius: 3px;
}

.attachments:hover {
  border: solid 1px #409EFF;
}

.compose-attachments .el-link {
  border: solid 1px #FFF;
  padding: 0 3px;
  border-radius: 4px;
}

.compose-attachments .el-link:hover {
  border: solid 1px #409EFF;
}

.el-icon-refresh:hover {
  cursor: pointer;
}

.composeForm {

  label,
  div,
  input {
    line-height: 20px;
  }

  input {
    height: 20px !important;
    white-space: pre-wrap;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
}

.el-upload-list {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/ALCMailer.vue